export default __webpack_public_path__ + "static/media/Girdle of the Martial Paragon.8a1bc7e1.jpg";